<div
  class="datepicker"
  (ppOnRendered)="onRendered()"
  [class.datepicker--disabled]="ppDisabled || ppIsLocked"
  [class.datepicker--error]="ppError"
  [class.datepicker--focused]="!!datepicker?.isOpen"
  (pointerdown)="onClick($event)"
  (mousedown)="onMouseDown($event)"
  ppTooltip
  [ppTitle]="ppIsLocked ? ('locked_by_admin' | ppTranslate) : null"
>
  <input
    #datepickerElement
    class="datepicker__input"
    type="text"
    [attr.aria-label]="ppPlaceholder"
    [placeholder]="ppPlaceholder"
    (keydown)="onKeydown($event)"
    [disabled]="ppDisabled || ppIsLocked"
    name="datePicker"
  />

  @if (ppIsLocked) {
    <pp-padlock-icon />
  }

  @if (ppShowClearButton) {
    <pp-save-indicator
      data-testid="save-indicator"
      [ppFocused]="datepicker?.isOpen"
      [ppMouseDownHandler]="true"
      [ppFilled]="ppShowClearButton"
      [ppUpdating]="ppUpdating"
      [ppShowClearBtn]="ppShowClearButton"
      (ppAction)="clearField()"
      (pointerdown)="$event.stopPropagation()"
      class="datepicker__save-indicator"
    />
  }

  @if (!ppDisabled && !ppUpdating && !ppIsLocked) {
    <div class="datepicker__icon-container">
      @if (ppShowCalendarIcon) {
        <pp-icon
          [ppSVG]="iconMap[EIconPath.ICON_FIELDS_DATE_18]"
          ppColor="grey-400"
          ppClass="setSize18"
        />
      } @else {
        <pp-icon
          data-testid="datePickerControlsIcon"
          [ppSVG]="
            datepicker?.isOpen
              ? iconMap[EIconPath.ICON_MISC_UP_ARROW_18]
              : iconMap[EIconPath.ICON_MISC_DOWN_ARROW_18]
          "
          ppColor="grey-400"
          ppClass="setSize18"
        />
      }
    </div>
  }
</div>
